import { faCirclePause } from '@fortawesome/pro-solid-svg-icons';

import { Text } from '@growtherapy/sprout-ui';

import { ModifiedToastAria, Toast, ToastVariant } from '../../toasts';

export function RequestingClientConsentToast({
  contentProps,
  descriptionProps,
  titleProps,
  ...toastAriaProps
}: ModifiedToastAria) {
  return (
    <Toast {...toastAriaProps} variant={ToastVariant.Info} icon={faCirclePause}>
      <div {...contentProps}>
        <span className='sr-only' {...titleProps}>
          Request sent.
        </span>
        <Text as='span' {...descriptionProps}>
          Requesting client consent for transcription...
        </Text>
      </div>
    </Toast>
  );
}
